import type { IconName } from "@aeroglobe/proxima-design-system";
import type { TravelerCount } from "@/core/types/flight/TravelerCount";

export enum TravelerTypes {
  ADULT = "ADT",
  ADLT = "ADLT",
  CHILD = "CNN",
  INFANT = "INF",
  CHLD = "CHLD",
  CHD = "CHD",
}

export function getPassengerTypeIcon(type: string): IconName {
  switch (type) {
    case TravelerTypes.ADULT:
      return "m-adult-traveler-icon";
    case TravelerTypes.ADLT:
      return "m-adult-traveler-icon";
    case TravelerTypes.CHILD:
      return "m-child-traveler-icon";
    case TravelerTypes.INFANT:
      return "m-infant-traveler-icon";
    case TravelerTypes.CHLD:
      return "m-child-traveler-icon";
    case TravelerTypes.CHD:
      return "m-child-traveler-icon";
    default:
      return "m-adult-traveler-icon";
  }
}

export function getTravelerTypeName(type: string) {
  switch (type) {
    case TravelerTypes.ADULT:
      return "Adult";
    case TravelerTypes.CHILD:
      return "Child";
    case TravelerTypes.INFANT:
      return "Infant";
    case TravelerTypes.CHLD:
      return "Child";
    case TravelerTypes.CHD:
      return "Child";
    default:
      return "Adult";
  }
}

export function getMaterialTravelerTypeName(type: string) {
  switch (type) {
    case TravelerTypes.ADULT:
      return "Adult";
    case TravelerTypes.ADLT:
      return "Adult";
    case TravelerTypes.CHILD:
      return "Child";
    case TravelerTypes.CHLD:
      return "Child";
    case TravelerTypes.INFANT:
      return "Infant";
    case TravelerTypes.CHD:
      return "Child";
    default:
      return "Adult";
  }
}
export function getMaterialTravelerTypeIcon(type: string) {
  switch (type) {
    case TravelerTypes.ADULT:
      return "m-adult-icon";
    case TravelerTypes.ADLT:
      return "m-adult-icon";
    case TravelerTypes.CHILD:
      return "m-child-icon";
    case TravelerTypes.CHLD:
      return "m-child-icon";
    case TravelerTypes.INFANT:
      return "m-infant-icon";
    case TravelerTypes.CHD:
      return "m-child-icon";
    default:
      return "m-adult-icon";
  }
}

export function getTravelerCountKey(type: string): keyof TravelerCount {
  switch (type) {
    case TravelerTypes.ADULT:
    case TravelerTypes.ADLT:
      return "adult_count";
    case TravelerTypes.CHILD:
    case TravelerTypes.CHD:
    case TravelerTypes.CHLD:
      return "child_count";
    case TravelerTypes.INFANT:
      return "infant_count";
    default:
      return "adult_count";
  }
}

export function getTravelerTypeFromCountKey(
  key: keyof TravelerCount,
): TravelerTypes {
  switch (key) {
    case "child_count":
      return TravelerTypes.CHILD;
    case "infant_count":
      return TravelerTypes.INFANT;
    case "adult_count":
    default:
      return TravelerTypes.ADULT;
  }
}
